const COLORS = {
  common: { black: "#000", white: "#fff", transparent: "transparent" },
  primary: {
    light: "#64ffda",
    main: "#00dfa8",
    dark: "#00ac79",
    contrastText: "rgba(0, 0, 0, .87)",
  },
  secondary: {
    light: "#7a81ab",
    main: "#2e2e46",
    dark: "#26263b",
    darkness: "#191b2a",
    contrastText: "rgba(255, 255, 255, .87)",
  },
  error: {
    light: "#ff7957",
    main: "#ed442c",
    dark: "#b30000",
    contrastText: "rgba(255, 255, 255, .87)",
  },
  info: {
    light: "#64eeff",
    main: "#0bbbd0",
    dark: "#008b9f",
    contrastText: "rgba(255, 255, 255, .87)",
  },
  warn: {
    light: "#ffe650",
    main: "#f1b40f",
    dark: "#b98500",
    contrastText: "rgba(0, 0, 0, .87)",
  },
  text: {
    primary: "rgba(255, 255, 255, .87)",
    secondary: "rgba(148, 158, 216, 1)",
    disabled: "rgba(122, 129, 171, 1)",
    disabledInvert: "rgba(255, 255, 255, 0.48)",
    hint: "rgba(155, 155, 155, 1)",
  },
  divider: {},
  background: {
    light: "#7a81ab",
    main: "#2e2e46",
    dark: "#191b2a",
    contrastText: "#FFFFFF",
    paper: "#26253B",
    default: "#26253B",
  },
  background_theme_secondary: {
    light: "#7a81ab",
    main: "#2e2e46",
    dark: "#020610",
    contrastText: "#fff",
    paper: "rgba(38, 38, 59, 1)",
    default: "rgba(38, 38, 59, 1)",
  },
};

export default COLORS;
